import { formatConfiguredTime } from '../../components/helpers'

import CardSectionPropertiesWithImage from '../../components/Card/CardSectionPropertiesWithImage.vue'
import CardPropertyObjectTable from '../../components/Card/CardPropertyObjectTable.vue'
import EmployeePropertyWorkAreaSchedule from './EmployeePropertyWorkAreaSchedule.vue'
import EmployeePropertyWorkShift from './EmployeePropertyWorkShift.vue'
import EmployeePropertySkills from './EmployeePropertySkills.vue'
import EmployeePropertySkudHistory from './EmployeePropertySkudHistory.vue'
import EmployeeSectionSkud from './EmployeeSectionSkud.vue'
import EmployeePropertyWorkArea from './EmployeePropertyWorkArea.vue'
import EmployeePropertyExperience from './EmployeePropertyExperience.vue'
import EmployeePropertyEmploymentPeriods from './EmployeePropertyEmploymentPeriods.vue'
import EmployeePropertyСommonWorkExperience from './EmployeePropertyСommonWorkExperience.vue'
import EmployeeActiveControlDocuments from './EmployeeActiveControlDocuments.vue'
import EmployeePropertyRolesList from './EmployeePropertyRolesList.vue'
import UserFaulties from '../../pages/main/sections/UserFaulties/UserFaulties.vue'
import CardPropertyObjectCustom from '../../components/Card/CardPropertyObjectCustom.vue'
import IssuedVehicleDocumentLink from '../../components/IssuedVehicleDocumentLink.vue'

export function getCustomTabsList (config) {
  const { small, create, createConfig, access, subtypeKey, objectData } = config
  const objectSrc = objectData && objectData.object || null
  const sync1C = !!(objectSrc && objectSrc.sync1C)
  const noSync1C = !sync1C

  const formatLastNotificationDateField = (value) => {
    return value && value.length ? formatConfiguredTime(value[value.length - 1], { year: true, month: true, date: true }) : ''
  }

  if (/* create || */ subtypeKey === 'forkLiftDriver') {
    return [
      {
        key: 'personalData',
        name: 'Основные параметры',
        props: [
          { key: 'fio', _editable: true, required: true, componentProps: { formatFio: true } },
          { key: 'phone2', name: 'Рабочий телефон', type: 'string', _dataType: 'phone', _icon: 'mdi-phone', _editable: true, required: true },
          { key: 'contractOrganization', _icon: 'mdi-domain', name: 'Организация подрядчика', _editable: true, required: true },
          { key: 'isContractor', _visible: access.fullAccess, _editable: false },
          { key: 'actualContractor', name: 'Актуальный', _visible: !create || access.vehicleProvisionApprovalAccess, _editable: access.vehicleProvisionApprovalAccess && !(createConfig && createConfig.actualContractorReadonly) },
          { key: 'forkLiftTruckDriver', _editable: false },
          {
            key: 'employeeWorkarea',
            _editable: false,
            component: EmployeePropertyWorkArea
          }]
      }
    ]
  } else if (small) {
    return [
      {
        key: 'personalData',
        name: 'Персональные данные',
        component: CardSectionPropertiesWithImage,
        componentProps: {
          imageEditable: false,
          imageSingle: true,
          expandCardOnImageClick: true, // !!small
          shiftedFieldsCount: 3,
          width: 101,
          height: 134
        },
        props: [
          // { key: '$D_workDate', name: 'Рабочий день', type: 'date', _editable: false },
          { key: '$D_workShift', code: '$D_workShift', name: 'Смена', type: 'listvalue', component: EmployeePropertyWorkShift, _customEdit: true, _editable: access.editEmployeeSchedule },
          { key: 'state', _editable: noSync1C },
          {
            key: 'employeeWorkarea',
            _editable: access.editPublic,
            component: EmployeePropertyWorkArea
          },
          {
            key: 'mainWorkAreaSchedule',
            name: 'Расписание направления работ',
            type: 'table',
            _editable: access.editPublic,
            component: EmployeePropertyWorkAreaSchedule,
            tablecolumns: [
              { name: 'startTime', label: 'Дата/время начала', type: 'datetime' },
              { name: 'endTime', label: 'Дата/время окончания', type: 'datetime' },
              { name: 'workShift', label: 'В рамках смены', type: 'boolean' },
              { name: 'workAreasNames', label: 'Направления работ', type: 'array' },
              { name: 'fio', label: 'Сотрудник' },
              { name: 'comment', label: 'Комментарий' }
            ],
            _disableFilter: true, // TODO
            _disablePagination: true // TODO
          },
          // { key: 'addWorkArea', _editable: access.editPublic, _select: true, listvalues: [], ismultiselect: true, objectchoosetypes: [{ key: 'workArea' }], objectchoosesubtypes: false },
          { key: 'position', _editable: noSync1C },
          { key: 'department', _editable: noSync1C },
          { key: '_contacts', type: 'separator', name: 'Контакты' },
          { key: 'phone2', name: 'Рабочий телефон', type: 'string', _dataType: 'phone', _icon: 'mdi-phone', _editable: noSync1C, componentProps: { copy: true } },
          { key: 'internalPhone', type: 'string', _dataType: 'phone', _icon: 'mdi-phone', _editable: false, componentProps: { copy: true } },
          { key: 'phone1', name: 'Личный телефон', type: 'string', _dataType: 'phone', _icon: 'mdi-phone', _editable: noSync1C, componentProps: { copy: true } },
          { key: 'workEmail', name: 'Рабочая почта', type: 'string', _icon: 'mdi-mail-ru', _editable: noSync1C, componentProps: { copy: true } },
          { key: 'persEmail', name: 'Личная почта', type: 'string', _icon: 'mdi-mail-ru', _editable: noSync1C, componentProps: { copy: true } }
        ]
      }
    ]
  } else {
    const admittancesTableTdStyleFn = function (col, row) {
      if (col.name === 'planReceiveTimeExpired' && row.planReceiveTimeExpired) {
        return 'background-color: #FF9393'
      } else if (col.name === 'name' && row.isJuniorGroup) {
        return 'background-color: #C4C4C4'
      }
    }
    const admittancesCardsTableTdStyleFn = function (col, row) {
      if (col.name === 'isCardReturned') {
        if (row.isCardReturned) {
          return 'background-color: #5feba8'
        } else if (row.hasToReturnCard) {
          return 'background-color: #FF9393'
        }
      }
      if (col.name === 'handNotification' && row.handNotification) {
        return 'background-color: #6cc2f8'
      }
    }
    return [
      {
        key: 'personalData',
        name: 'Персональные данные',
        nameWordWrap: ['Персональные', 'данные'],
        component: CardSectionPropertiesWithImage,
        componentProps: {
          imageEditable: access.editImage,
          imageSingle: true,
          shiftedFieldsCount: 4,
          width: 136,
          height: 182
        },
        props: [
          { key: 'fio', _editable: noSync1C }, // sync1C
          { key: 'gender', _editable: noSync1C }, // sync1C
          { key: 'tabNum', _editable: false }, // sync1C
          { key: 'user', _icon: 'mdi-account-box-outline', _editable: false, componentProps: { copy: true } },
          { key: 'birthday', _editable: noSync1C },
          // { key: '$key', access: 'admin' },
          {
            key: 'state',
            type: 'listvalue',
            _editable: noSync1C, // sync1C - вычисляемое
            componentProps: {
              class: function (value, object) {
                if (value === 'work') {
                  return 'd-field--shadow-green'
                } else if (value === 'dismissed') {
                  return 'd-field--shadow-red'
                }
              }
            }
          },
          { key: 'currentStatus', type: 'string', _editable: false },
          { key: 'currentStatusEndDate', name: 'Дата окончания действия текущего статуса сотрудника', type: 'date', _editable: false },
          { key: 'organization', _icon: 'mdi-domain', _editable: noSync1C, componentProps: { copy: true } }, // TO DO: string -> object
          { key: 'position', _editable: noSync1C },
          { key: 'department', _editable: noSync1C, componentProps: { copy: true } },
          { key: 'employeeAdditionalDepartment', name: 'Дополнительные отделы, на которые распространяются полномочия', type: 'objects', componentProps: { copy: true } },
          // Актуальность данных о подразделении
          // Ссылка на персональные данные пользователя
          {
            key: 'employmentPeriods',
            component: EmployeePropertyEmploymentPeriods,
            name: 'Периоды работы',
            _editable: access.editPublic,
            initialSortFn (a, b) {
              return a.employmentDate - b.employmentDate
            }
          },
          { key: 'employmentDate', name: 'Дата приёма', _editable: noSync1C },
          { key: 'resignationDate', name: 'Дата увольнения', _editable: noSync1C },
          { key: 'vacationRest', name: 'Количество дней оставшегося отпуска', _editable: false, componentProps: { placeholder: 'Не пришли данные из 1С' } },
          { key: 'vacationSplit', name: 'Количество дней отпуска по периодам', _editable: false, componentProps: { placeholder: 'Не пришли данные из 1С' } },
          { key: '_contacts', type: 'separator', name: 'Контакты' },
          { key: 'phone2', name: 'Рабочий телефон', type: 'string', _dataType: 'phone', _icon: 'mdi-phone', _editable: noSync1C, componentProps: { copy: true } },
          { key: 'internalPhone', type: 'string', _dataType: 'phone', _icon: 'mdi-phone', _editable: false, componentProps: { copy: true } },
          { key: 'phone1', name: 'Личный телефон', type: 'string', _dataType: 'phone', _icon: 'mdi-phone', _editable: noSync1C, componentProps: { copy: true } },
          { key: 'email', name: 'Почта для рассылок', type: 'string', _icon: 'mdi-mail-ru', _editable: noSync1C, componentProps: { copy: true } },
          { key: 'workEmail', name: 'Рабочая почта', type: 'string', _icon: 'mdi-mail-ru', _editable: noSync1C, componentProps: { copy: true } },
          { key: 'persEmail', name: 'Личная почта', type: 'string', _icon: 'mdi-mail-ru', _editable: noSync1C, componentProps: { copy: true } },
          // ... Контакты и комментарии
          // Типы рабочих смен
          // Участвует в выездах
          // Автоматическое назначения исполнителем
          // Исполнитель работ по заявкам
          { key: '_contractor', type: 'separator', name: 'Сотрудник Подрядчика' },
          { key: 'isContractor' },
          { key: 'forkLiftTruckDriver' },
          { key: 'contractOrganization', _icon: 'mdi-domain', name: 'Организация подрядчика', componentProps: { copy: true } },
          { key: '_clothes', type: 'separator', name: 'Спецодежда' },
          { key: 'height', _editable: noSync1C },
          { key: 'clothesSize', _editable: noSync1C },
          { key: 'shoeSize', _editable: noSync1C }
        ]
      },
      {
        key: 'qualification',
        name: 'Квалификация/Допуски',
        nameWordWrap: ['Квалификация/', 'Допуски'],
        _visible: access.viewPrivate,
        props: [
          {
            key: 'role',
            _editable: access.editPublic,
            component: EmployeePropertyRolesList,
            _useItemsSearchField: true
            // _prepare: function (user) {
            //   if (Array.isArray(this.listvalues)) {
            //     this.listvalues = this.listvalues.filter(obj => {
            //       if (user.hasSystemRole('AllOperations')) {
            //         return true
            //       }
            //       switch (obj.value) {
            //         case 'admin':
            //         case 'transportAdmin':
            //         case 'medicalAdmin':
            //         case 'orderAdmittance':
            //         case 'metroOrderAdmittance':
            //         case 'processDemountigStocks':
            //         case 'purchaseApplicant':
            //         case 'purchaseAddviewer':
            //         case 'purchasePerformer':
            //         case 'purchaseViewer':
            //         case 'purchaseConfirmator':
            //         case 'blockedNomAdmin':
            //         case 'externalDispatcher':
            //         case 'vehicleProvisionCoordinator':
            //         case 'vehicleProvisionApprover':
            //         case 'workQualityReader':
            //         case 'workQualityCustomer':
            //         case 'workQualityReviewer':
            //         case 'workQualityApprover':
            //         case 'workQualityAgreementr':
            //           Vue.set(obj, '_accessible', user.hasRole('admin'))
            //           return true
            //         case 'medical':
            //           Vue.set(obj, '_accessible', user.hasRole('admin', 'medicalAdmin'))
            //           return true
            //         case 'blockedNomAcceptor':
            //           Vue.set(obj, '_accessible', user.hasRole('admin', 'blockedNomAdmin'))
            //           return true
            //         case 'stockAccessoryControl':
            //           Vue.set(obj, '_accessible', user.fullAccess || user.hasRole('admin') && user.hasOperation('stockAccessoryControl'))
            //           return true
            //         case 'dispatcher':
            //         case 'reportchecker':
            //         case 'officeemployee':
            //         case 'brigadier':
            //         case 'brigademember':
            //         case 'remontRequestCreator':
            //         case 'remontRequestPerformer':
            //         case 'addResponsibleEmployeeComments':
            //         case 'serviceObjectDeviceEventJournalReader':
            //         case 'workNormAdmin':
            //         case 'simpleWorkCreator':
            //         case 'undefined':
            //           return true
            //         default:
            //           return false
            //       }
            //     })
            //   }
            // }
          },
          { key: 'workShiftDispatcher', name: 'Сменный', type: 'boolean', _editable: access.editPublic, _show: o => o.role && o.role.length && o.role.includes('dispatcher') },
          {
            key: 'employeeWorkarea', // !!!
            _editable: access.editPublic,
            component: EmployeePropertyWorkArea
          },
          {
            key: 'mainWorkAreaSchedule',
            name: 'Расписание направления работ',
            type: 'table',
            _editable: true,
            component: EmployeePropertyWorkAreaSchedule,
            tablecolumns: [
              { name: 'startTime', label: 'Дата/время начала', type: 'datetime' },
              { name: 'endTime', label: 'Дата/время окончания', type: 'datetime' },
              { name: 'workShift', label: 'В рамках смены', type: 'boolean' },
              { name: 'workAreasNames', label: 'Направления работ', type: 'array' },
              { name: 'fio', label: 'Сотрудник' },
              { name: 'comment', label: 'Комментарий' }
            ],
            _disableFilter: true, // TODO
            _disablePagination: true // TODO
          },
          // Ограничен направлением работ
          { key: 'workAreaBounded', _visible: access.fullAccess },
          // Умения, навыки
          { key: '_skills', type: 'separator' },
          { key: 'engineerScore', _editable: access.editPublic },
          { key: 'montageScore', _editable: access.editPublic },
          {
            key: 'skillUsual',
            code: 'skillUsual',
            saveRawData: true,
            name: 'Навыки',
            type: 'objects',
            _editable: access.editEmployeeSkills,
            _visible: access.viewEmployeeSkills,
            component: EmployeePropertySkills,
            componentProps: {
              columns: [
                { name: 'name', label: 'Название', type: 'string' },
                { name: 'level', label: 'Уровень', type: 'string' }
              ],
              rowsPerPage: 0,
              hideBottom: true,
              admittance: false
            }
          },
          {
            key: 'skillRequiredAdmittance',
            code: 'skillRequiredAdmittance',
            saveRawData: true,
            name: 'Обязательные виды допуска (квалификации)',
            type: 'objects',
            _editable: access.editEmployeeSkills,
            _visible: access.viewEmployeeSkills,
            initialSortFn: (r1, r2) => {
              let result = r1.name.localeCompare(r2.name)
              if (result !== 0) {
                return result
              }
              result = r1.qualificationTypeKey.localCompare(r2.qualificationTypeKey)
              if (result !== 0) {
                return result
              }
              result = r1.qualificationGroup.localCompare(r2.qualificationGroup)
              return result
            },
            component: EmployeePropertySkills,
            componentProps: {
              columns: [
                { name: 'name', label: 'Название', type: 'string', headerStyle: 'width: 250px; white-space: normal', style: 'white-space: normal', componentProps: { tdStyle: admittancesTableTdStyleFn } },
                { name: 'qualificationGroup', label: 'Группа допуска', headerStyle: 'width: 100px; white-space: normal', type: 'string', componentProps: { tdStyle: admittancesTableTdStyleFn } },
                { name: 'planReceiveTime', label: 'Плановая дата получения (продления)', headerStyle: 'width: 170px; white-space: normal', type: 'date', componentProps: { tdStyle: admittancesTableTdStyleFn, noDataText: 'Нет данных' } },
                { name: 'isActive', label: 'Действует', headerStyle: 'width: 100px; white-space: normal', type: 'boolean', componentProps: { tdStyle: admittancesTableTdStyleFn } },
                { name: 'planReceiveTimeExpired', label: 'Срок выдачи (продления) истек', headerStyle: 'width: 170px; white-space: normal', type: 'boolean', componentProps: { tdStyle: admittancesTableTdStyleFn } },
                { name: 'isBlocked', label: 'Заблокирован', type: 'boolean', componentProps: { tdStyle: admittancesTableTdStyleFn } }
              ],
              admittance: true,
              admittanceType: 'requiredAdmittance'
            }
          },
          {
            key: 'skillAdmittance',
            code: 'skillAdmittance',
            saveRawData: true,
            name: 'Необязательные виды допуска (квалификации)',
            type: 'objects',
            _editable: access.editEmployeeSkills,
            _visible: access.viewEmployeeSkills,
            initialSortFn: (r1, r2) => {
              let result = r1.name.localeCompare(r2.name)
              if (result !== 0) {
                return result
              }
              result = r1.qualificationTypeKey.localCompare(r2.qualificationTypeKey)
              if (result !== 0) {
                return result
              }
              result = r1.qualificationGroup.localCompare(r2.qualificationGroup)
              return result
            },
            component: EmployeePropertySkills,
            componentProps: {
              columns: [
                { name: 'name', label: 'Название', type: 'string', headerStyle: 'width: 250px; white-space: normal', style: 'white-space: normal', componentProps: { tdStyle: admittancesTableTdStyleFn } },
                { name: 'qualificationGroup', label: 'Группа допуска', headerStyle: 'width: 100px; white-space: normal', type: 'string', componentProps: { tdStyle: admittancesTableTdStyleFn } },
                { name: 'planReceiveTime', label: 'Плановая дата получения (продления)', headerStyle: 'width: 170px; white-space: normal', type: 'date', componentProps: { tdStyle: admittancesTableTdStyleFn, noDataText: 'Нет данных' } },
                { name: 'isActive', label: 'Действует', headerStyle: 'width: 100px; white-space: normal', type: 'boolean', componentProps: { tdStyle: admittancesTableTdStyleFn } },
                { name: 'planReceiveTimeExpired', label: 'Срок выдачи (продления) истек', headerStyle: 'width: 170px; white-space: normal', type: 'boolean', componentProps: { tdStyle: admittancesTableTdStyleFn } },
                { name: 'isBlocked', label: 'Заблокирован', type: 'boolean', componentProps: { tdStyle: admittancesTableTdStyleFn } }
              ],
              admittance: true,
              admittanceType: 'nonRequiredAdmittance'
            }
          },
          {
            key: 'noSkillAdmittance',
            code: 'noSkillAdmittance',
            saveRawData: true,
            name: 'Заблокированные виды допуска (квалификации)',
            type: 'objects',
            _editable: access.editEmployeeSkills,
            _visible: access.viewEmployeeSkills,
            component: EmployeePropertySkills,
            componentProps: {
              columns: [
                { name: 'name', label: 'Название', headerStyle: 'width: 250px; white-space: normal', style: 'white-space: normal', type: 'string' },
                { name: 'reason', label: 'Причина', headerStyle: 'width: 250px; white-space: normal', type: 'string' },
                { name: 'blockTime', label: 'Дата', type: 'date' }
              ],
              admittance: true,
              admittanceType: 'blockedAdmittance'
            }
          },
          {
            key: 'skillAdmittanceCertificate',
            code: 'skillAdmittance',
            saveRawData: true,
            name: 'Удостоверения о допуске (квалификации)',
            type: 'objects',
            _editable: access.editEmployeeSkills,
            _visible: access.viewEmployeeSkills,
            component: EmployeePropertySkills,
            componentProps: {
              columns: [
                { name: 'name', label: 'Название', headerStyle: 'width: 250px; white-space: normal', style: 'white-space: normal', type: 'string', componentProps: { tdStyle: admittancesCardsTableTdStyleFn } },
                { name: 'startValidTime', label: 'Дата начала действия документа', headerStyle: 'width: 170px; white-space: normal', type: 'date', componentProps: { tdStyle: admittancesCardsTableTdStyleFn } },
                { name: 'endValidTime', label: 'Дата окончания действия документа', headerStyle: 'width: 170px; white-space: normal', type: 'date', componentProps: { tdStyle: admittancesCardsTableTdStyleFn } },
                { name: 'qualificationPosition', label: 'Должность при получении', headerStyle: 'width: 190px; white-space: normal', type: 'date', componentProps: { tdStyle: admittancesCardsTableTdStyleFn } },
                { name: 'isActive', label: 'Действует', headerStyle: 'width: 100px; white-space: normal', type: 'boolean', componentProps: { tdStyle: admittancesCardsTableTdStyleFn } },
                { name: 'isRequired', label: 'Обязательный', headerStyle: 'width: 120px; white-space: normal', type: 'boolean', componentProps: { tdStyle: admittancesCardsTableTdStyleFn } },
                { name: 'qualificationDocumentTypeAlias', label: 'Тип документа', type: 'boolean', componentProps: { tdStyle: admittancesCardsTableTdStyleFn } },
                { name: 'hasToReturnCard', field: row => row.hasToReturnCard ? row.hasToReturnCard : null, label: 'Требуется сдать удостоверение', headerStyle: 'width: 170px; white-space: normal', type: 'boolean', componentProps: { tdStyle: admittancesCardsTableTdStyleFn } },
                { name: 'isCardReturned', field: row => row.hasToReturnCard == null ? null : row.isCardReturned, label: 'Удостоверение сдано', headerStyle: 'width: 170px; white-space: normal', type: 'boolean', componentProps: { tdStyle: admittancesCardsTableTdStyleFn } },
                { name: 'dailyNotification', field: row => row.dailyNotification ? row.dailyNotification : null, label: 'Ежедневное уведомление', headerStyle: 'width: 170px; white-space: normal', type: 'boolean', componentProps: { tdStyle: admittancesCardsTableTdStyleFn } },
                { name: 'lastNotificationDate', label: 'Дата последней отправки', field: 'notificationDates', headerStyle: 'width: 170px; white-space: normal', format: formatLastNotificationDateField, componentProps: { tdStyle: admittancesCardsTableTdStyleFn, noExtraFormat: true } },
                {
                  name: 'notificationDates',
                  field: 'notificationDates',
                  label: 'Количество уведомлений',
                  format: value => {
                    return value && value.length ? value.length : ''
                    // return value && value.length ? value.map(d => formatTime(d)).join(', ') : ''
                  },
                  sortable: false,
                  componentProps: {
                    noExtraFormat: true
                  }
                }
              ],
              admittance: true,
              admittanceType: 'skillAdmittanceCertificate'
            }
          },
          {
            key: 'skillArchive',
            code: 'skillArchive',
            saveRawData: true,
            name: 'Архив удостоверений о допуске (квалификации)',
            type: 'objects',
            _editable: false,
            _visible: access.viewEmployeeSkills,
            component: EmployeePropertySkills,
            componentProps: {
              columns: [
                { name: 'name', label: 'Название', headerStyle: 'width: 250px; white-space: normal', style: 'white-space: normal', type: 'string' },
                { name: 'startValidTime', label: 'Дата начала действия документа', headerStyle: 'width: 170px; white-space: normal', type: 'date' },
                { name: 'endValidTime', label: 'Дата окончания действия документа', headerStyle: 'width: 170px; white-space: normal', type: 'date' },
                { name: 'qualificationPosition', label: 'Должность при получении', headerStyle: 'width: 190px; white-space: normal', type: 'date' },
                { name: 'isActive', label: 'Действует', headerStyle: 'width: 100px; white-space: normal', type: 'boolean' },
                { name: 'isRequired', label: 'Обязательный', headerStyle: 'width: 120px; white-space: normal', type: 'boolean' },
                { name: 'qualificationDocumentTypeAlias', label: 'Тип документа', type: 'boolean' }
              ],
              admittance: true,
              admittanceType: 'skillArchive'
            }
          },
          // -
          { key: '_instructions', name: 'Инструктаж', type: 'separator' },
          { key: 'familiarizedWithCommonInstructions', name: 'Ознакомлен с вводным инструктажем', type: 'boolean', _visible: access.viewEmployeeSkills, _editable: access.editEmployeeSkills },
          { key: 'signedCommonInstructionsInJournal', name: 'Подписал вводный инструктаж в журнале', type: 'boolean', _visible: access.viewEmployeeSkills, _editable: access.editEmployeeSkills },
          { key: 'familiarizedWithMicrotraumaRegistrationProcedure', name: 'Ознакомлен с порядком учёта микроповреждений (микротравм)', type: 'boolean', _visible: access.viewEmployeeSkills, _editable: access.editEmployeeSkills },
          // -
          { key: '_driversLicense', name: 'Водительское удостоверение', type: 'separator' },
          { key: 'driversLicense', name: 'Номер', type: 'string', _editable: access.editPublic, componentProps: { copy: true } },
          { key: 'driverLicenseIssuanceDate', name: 'Дата выдачи', type: 'date', _editable: access.editPublic },
          { key: 'driversLicenseEndData', name: 'Окончание действия', type: 'date', _editable: access.editPublic },
          { key: 'driverVehiclesCategories', name: 'Категории ТС', type: 'listvalue', _editable: access.editPublic },
          // { key: 'driversLicenseState', name: 'Статус', type: 'listvalue' },
          // -
          { key: '_driverAccess', type: 'separator' },
          { key: 'consentToDrive', _editable: access.editPublic }, // ?
          // -
          { key: '_other', type: 'separator' },
          // { key: 'medperson', _icon: 'mdi-mortar-pestle-plus' },
          { key: 'workOvertimeReadiness', _editable: access.editPublic },
          // -
          { key: '_yandexAccounts', name: 'Учетная запись Яндекс', type: 'separator' },
          {
            key: 'accountEmployee',
            name: 'Учетная запись Яндекс (собственная)',
            type: 'object',
            component: CardPropertyObjectCustom,
            subType: 'yandexAccount',
            componentProps: {
              select: true,
              cached: false,
              createConfig: {
                updateOnCreated: true,
                objectParams: function (objectSrc) {
                  return {
                    accountEmployee: objectSrc.id
                  }
                }
              }
            }
          },
          {
            key: 'accountAssignedEmployee',
            name: 'Назначенная учетная запись Яндекс',
            type: 'object',
            component: CardPropertyObjectCustom,
            subType: 'yandexAccount',
            componentProps: {
              select: true,
              cached: false
            }
          }
        // Допуски
        // { key: '_admittances', type: 'separator', name: 'Допуски' },
        // { key: 'departureAdmittances' },
        // { key: 'officeAddmitances' },
        // { key: 'blockedSkills' },
        // // -
        // { key: 'ordinaryMedicalJournal' }, // ?
        // { key: 'medicalJournal' } // ?
        ]
      },
      {
        key: 'accessedDocumentsWorkAreas',
        name: 'Доступ к документам',
        nameWordWrap: ['Доступ к', 'документам'],
        control: 0,
        _visible: access.accessControl,
        component: EmployeeActiveControlDocuments,
        props: [
          {
            key: 'amountControl', type: 'any', code: 'amountControl'
          },
          {
            key: 'documentsAccessedWorkAreas', type: 'listvalue', code: 'documentsAccessedWorkAreas', ismultiselect: true
          }
        ]
      },
      {
        key: 'brigade',
        name: 'Бригада',
        props: [
          { key: 'employee', name: 'Текущая бригада', componentProps: { copy: true } },
          // Бригадир - Признак того, что сотрудник назначен бригадиром
          { key: 'fixedEmployee', name: 'Зафиксированная бригада', _editable: access.editPublic, componentProps: { copy: true } }
        // -
        // { key: 'role' },
        // { key: 'employeeWorkarea' },
        // { key: 'addWorkArea' }
        // -
        // { key: 'assignWithExperiencedEmployee' }, // ?
        // { key: 'canBeBrigadier' }, // ?
        ]
      },
      {
        key: 'requisite',
        name: 'Реквизит',
        _visible: access.viewPrivate,
        props: [
          { key: 'stockBox', name: 'Ящик' },
          {
            key: 'toolEmployee',
            name: 'Инструменты',
            type: 'objects',
            _editable: false,
            component: CardPropertyObjectTable,
            componentProps: {
              columns: [
                { name: 'name', label: 'Название', type: 'string' },
                { name: 'amount', label: 'Количество', type: 'string' },
                { name: 'takeTime', label: 'Дата выдачи', type: 'date' },
                { name: 'nomAffilation', label: 'Тип номенклатуры', type: 'string' },
                { name: 'invN', label: 'Инвентарный номер', type: 'string' },
                { name: 'serial', label: 'Серийный номер', type: 'string' },
                {
                  name: 'storagePlace',
                  label: 'Место нахождения',
                  field: row => row.storagePlace && row.storagePlace.name ? row.storagePlace : null,
                  columnFormat: 'object'
                }
              ],
              rowsPerPage: 20,
              searchColumns: ['name', 'invN', 'serial', 'storagePlace']
            }
          },
          { key: 'box', name: 'Шкафчик', _editable: noSync1C },
          { key: 'geotrackerEmployee', name: 'Геотрекер', componentProps: { copy: true } },
          {
            key: 'vehicleEmployee',
            name: 'Транспортные средства',
            type: 'objects',
            _editable: false,
            component: CardPropertyObjectTable,
            componentProps: {
              hideHeader: true,
              hideBottom: true,
              rowsPerPage: 0,
              objectType: 'vehicle',
              columns: [
                {
                  name: 'name',
                  label: 'Название',
                  field: row => ({ id: row.id, name: row.name, type: 'vehicle' }),
                  columnFormat: 'object'
                },
                {
                  name: 'issuanceDocument',
                  label: '',
                  field: 'id',
                  sortable: false,
                  component: IssuedVehicleDocumentLink,
                  componentProps: {
                    autoWidth: true
                  }
                }
              ]
            }
          },
          {
            key: 'responsiblePerson',
            name: 'Топливные карты',
            type: 'objects',
            _editable: false,
            _visible: access.viewFuelCards,
            component: CardPropertyObjectTable,
            componentProps: {
              url: '/service/obj/search?type=fuelCard&subtypes=false&page=1&start=0&limit=1000&sort=param.order&dir=ASC&params=' + encodeURI(JSON.stringify([{ param: 'valid', type: 'boolean', action: '=', value: true }, { param: 'order', type: 'integer', action: 'any' }]))
            }
          }
        ]
      },
      {
        key: 'skudData',
        name: 'СКУД',
        _visible: access.viewPrivate,
        component: EmployeeSectionSkud,
        props: [
        // { key: 'skudTime', name: 'Время' },
        // { key: 'skudEvent', name: 'Событие' },
        // { key: 'skudInfo', name: 'Дополнительная информация' },
          { key: 'skudHistory', name: 'Данные по СКУД', type: 'table', component: EmployeePropertySkudHistory, componentProps: { interval: null }, _editable: false }
        ]
      },
      {
        key: 'achievements',
        name: 'Достижения',
        _visible: access.viewEmployeeAchievements,
        props: [
          {
            key: 'workExperienceText',
            _editable: false,
            type: 'String',
            name: 'Стаж',
            _icon: 'mdi-timer-star-outline',
            component: EmployeePropertyExperience
          },
          { key: 'honored', name: 'Выдающийся сотрудник', type: 'boolean', _editable: access.editEmployeeAchievements, _icon: 'mdi-star' },
          { key: 'employmentDate', name: 'Дата приёма', _editable: noSync1C },
          { key: 'workExperienceStartDate', name: 'Дата отсчёта стажа', _editable: access.editEmployeeAchievements },
          {
            key: 'commonWorkExperience',
            _editable: access.editEmployeeAchievements,
            type: 'boolean',
            name: 'Учитывать дату отсчёта стажа',
            component: EmployeePropertyСommonWorkExperience
          },
          { key: 'commentExperience', name: 'Комментарий', _editable: access.editEmployeeAchievements }
        ]
      },
      {
        key: 'userFaulties',
        name: 'Журнал замечаний',
        component: UserFaulties,
        _visible: access.viewPrivate
      },
      {
        key: 'userDevices',
        name: 'Журнал устройств',
        nameWordWrap: ['Журнал', 'устройств'],
        _visible: access.fullAccess,
        props: [
          {
            key: 'userDevices',
            name: '',
            type: 'table',
            _editable: false,
            tablecolumns: [
              { name: 'firstTime', label: 'Дата/время первого входа', type: 'datetime' },
              { name: 'lastTime', label: 'Дата/время последнего входа', type: 'datetime' },
              { name: 'deviceName', label: 'Устройство' },
              { name: 'deviceType', label: 'Тип устройства' },
              { name: 'mobile', label: 'Мобильное устройство', type: 'boolean' },
              { name: 'screen', label: 'Разрешение экрана', field: (row) => row.screenWidth && row.screenHeight && `${row.screenWidth}x${row.screenHeight}` },
              { name: 'deviceMemory', label: 'Оперативная память, ГБ' }
            ]
          }
        ]
      }
    // ,{ key: 'vehicle', name: 'ТС', props: [ { key: 'consentToDrive' }, { key: 'vehicleEmployee' }] }
    // ,{ key: 'additionalInfo', name: 'Дополнительная информация ', access: 'admin', props: [] }
    ]
  }
}
